import { render, staticRenderFns } from "./LoadPage.vue?vue&type=template&id=504f46c2&"
import script from "./LoadPage?vue&type=script&lang=js&"
export * from "./LoadPage?vue&type=script&lang=js&"
import style0 from "./LoadPage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports